import { CommandType } from "~app/common/services/cqs/CommandType";
import { ArbetsorderKartutsnittBaseCommand } from "./ArbetsorderKartutsnittBaseCommand";
export class DeleteArbetsorderKartutsnittCommand extends ArbetsorderKartutsnittBaseCommand {
// eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "DeleteArbetsorderKartutsnittCommand";
    constructor(kartutsnittId: string, arbetsorderId: number) {
        super(DeleteArbetsorderKartutsnittCommand.$type, CommandType.Delete);
        this.arbetsorderId = arbetsorderId;
        this.kartutsnittId = kartutsnittId;
    }
}
